module.exports = __webpack_public_path__ + "a40bd8fbc5f9c78b91022a66a1b04c85.jpg";


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/banner-bg.jpg
// module id = 304
// module chunks = 0